import type { Board, Profession, Story } from '@mezha/api'

export function chapterTitle(id: string) {
  return ({ S1: 'Пустой столб', S2: 'Чернильный город', S2_SIDE: 'Истории жителей Горстеня · побочные', S3: 'Расколотый мост', S3_SIDE: 'Истории жителей Расколья · побочные' } as Record<string, string>)[id] ?? id
}

export function publishedStoryComplete(story: Story) {
  return !!story.chapters?.length && story.chapters.every(c => c.total > 0 && c.completed >= c.total)
}

export function currentOrders(board: Board) {
  return [...new Map([...board.offers, ...board.taken].map(o => [o.id, o])).values()]
    .filter(o => ['active', 'ready_to_claim', 'offered'].includes(o.status))
    .sort((a, b) => ['ready_to_claim', 'active', 'offered'].indexOf(a.status) - ['ready_to_claim', 'active', 'offered'].indexOf(b.status))
}

export function nextRecipe(p: Profession) {
  return [...p.recipes].filter(r => !r.open).sort((a, b) => a.level - b.level || a.hero_level - b.hero_level || a.id.localeCompare(b.id))[0]
}

export function progressValue(value: number, start: number, end: number | null) {
  return end === null || end <= start ? 100 : Math.min(100, Math.max(0, (value - start) / (end - start) * 100))
}
